import { TFunction } from 'i18next';

export const PRODUCT_NAME_MAX_LENGTH = 255;
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 500;
export const PRODUCT_SKU_MAX_LENGTH = 12;
export const PRODUCT_GTIN_MAX_LENGTH = 14;
export const PRODUCT_ID_MAX_LENGTH = 100;

export function translateProductLabel(
  t: TFunction,
  type: 'commodity' | 'variety' | 'product',
  key: string,
  fallback: string
): string {
  return t(`products.${type}.${key}`, { defaultValue: fallback });
}
